/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import ContenidoList from './ContenidoList';
import {bindActionCreators} from 'redux';
import * as contenidoActions from '../../actions/contenidoActions';
 
import toastr from 'toastr';
import ManageList from '../common/ManageList';
import { Segment} from 'semantic-ui-react';
import ModalSiNo from '../common/ModalSiNo';
import $ from 'jquery';
import {getMargenes} from '../../util/';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import {Auth} from 'aws-amplify';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';
import * as cursoActions from '../../actions/cursoActions';
import {genericFormattedForDropdown} from '../../selectors/selectors';


class ManageContenidoList extends ManageList  {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            errors:{},
            strings:[],
            showActivos:true,
            filtrosCombo:{
                curso:"",
                opcional:true
            },
            permisos:{}
		};
	}

	componentDidMount(){
        
        usuarioActual(this, "Contenido",true).then( (usuario)=>{
           window.scrollTo(0, 0);
           this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
            
            this.props.cursoActions.getCursoCombo( usuario).then( ()=>{

                })
                    .catch(error=>{
                      toastr.error(error);
                });    
            
            
		   if(this.props.user!=null)
		      this.inicializa();
       })
        .catch(error=>{
          toastr.error(error);
        }); 
        
        
        
        
   
	}
        
  
    
    render() {
         
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		return (
            <Segment  style={margenes}>
                  
                <ContenidoList
                    strings={this.props.strings}
                    contenido={this.props.listado.content}
                    activePage={this.props.listado.paginaActual+1}
                    handleSelectPagination={this.handleSelectPagination}
                    totalPages={this.props.listado.totalPages}
                    handleChange= {this.handleChangeFiltro}
                    filtro={this.state.filtro}
                    onFiltrarInformacion={this.onFiltrarInformacion}
                    filtroActivo={this.props.listado.filtroActivo}
                    filtroActual={this.props.listado.filtroActual}
                    onDesactivarFiltro={this.onDesactivarFiltro}
                    confirmarBorrado={this.confirmarBorrado}
                    onShowModalBorrar={this.onShowModalBorrar}
                    onShowModalActivar={this.onShowModalActivar}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    handleChangeFiltro= {this.handleChangeFiltro}
                    handleChangeActivos={this.handleChangeActivos}
                    showActivos={this.props.listado.showActivos}
                    color={this.props.color}
				    form={this.props.form}
                    permisos={this.state.permisos}
                    filtrosCombo={this.props.listado.filtrosCombo}
                    handleChangeFiltroCombo= {this.handleChangeFiltroCombo}
                    cursosCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    errors={this.state.errors}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalBorrar}
                    closeModal={this.oncloseModal}
                    borrar={this.borrar}
                    icono={"trash"}
                    texto={"Esta seguro que desea eliminar este registro de forma permanente?"}
                    titulo={this.state.strings?this.state.strings["Contenido"]:""}
                />
            
                <ModalSiNo
                    showModal={this.state.showModalActivar}
                    closeModal={this.oncloseModal}
                    borrar={this.activar}
                    icono={"exchange"}
                    texto={"Esta seguro que desea cambiar el esatus del registro?"}
                    titulo={this.state.strings?this.state.strings["Contenido"]:""}
                 />

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    return {
        listado:state.contenido,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        permisos:state.permisos,
        form:state.form,
        user:state.user, 
        idioma:state.idioma,
        cursoCombo:state.cursoCombo,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
        menuActions:bindActionCreators(menuActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        listadoActions: bindActionCreators(contenidoActions, dispatch),
        load:bindActionCreators(contenidoActions.getContenidoList, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageContenidoList);